import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SearchData } from './models/search-data';

@Injectable({
  providedIn: 'root',
})
export class AiSearchService {
  public _http: HttpClient;
  public baseUrlLocal: string = "";

  constructor(private http: HttpClient) {
      this._http = http;
      this.baseUrlLocal = environment.apiBaseUrl;
  }

  public searchItemsWithFilters(searchData: SearchData): Observable<SearchData> {
    return this._http.post<SearchData>(`${this.baseUrlLocal}aisearch`, searchData);
  }
}
